<template>
  <div>
    <card
      v-if="card.visible"
      :id="card.id"
      :key="card.id"
      :title="card.title"
      :title-action="card.titleAction"
      :capitalize-subtitle="card.capitalizeSubtitle"
      :subtitle-regular="card.subtitleRegular"
      :transparent-card="card.transparentCard"
      :buttons="card.buttons"
      :class="{ 'card-disabled': card.disabled }"
      @click="action"
    >
      <component
        :is="card.component.name"
        v-if="card.component"
        :key="card.component.key"
        :content="card.component.content"
      />
      <infotip
        v-if="card.disabled"
        :id="card.id + '-disabled'"
        :key="card.id + '-infotip-disabled'"
        :text="
          card.disabledMessage ||
            'A funcionalidade está temporariamente em manutenção.'
        "
        :auto-open-on-first-days="false"
        :never-open-again-after-dismissed="false"
        :close-on-mouse-leave="true"
      />
    </card>
  </div>
</template>

<script>
import Card from '../Card'
import ImportXml from '../Widgets/ImportXml'
import Infotip from '@/components/common/infotip/Infotip'

import { mapGetters } from 'vuex'

export default {
  name: 'CardDailyRoutine',
  components: {
    card: Card,
    infotip: Infotip,
    'import-xml': ImportXml
  },
  computed: {
    ...mapGetters(['toggle']),
    card () {
      return {
        id: 'dailyRoutine',
        visible: !this.toggle.covax,
        disabled: !this.toggle.xmlImport,
        title: 'Rotinas diárias',
        subtitleRegular: 'Importe um XML ou cadastre manualmente',
        template: {
          flex: 40,
          column: 1,
          row: 3
        },
        buttons: [
          {
            id: 'btnDashboardRegister',
            text: 'cadastrar manualmente',
            style: 'btn-secondary-pink',
            action: 'Cadastro Manual',
            visible: this.toggle.manualServiceOrderRegistration
          }
        ],
        component: {
          name: 'import-xml',
          key: 3,
          content: {
            text: 'Importar arquivo XML',
            icon: 'xml-pink',
            sizeSmall: true
          }
        }
      }
    }
  },
  methods: {
    action () {
      this.$router.push('orders/new')
    }
  }
}
</script>
